import { pluralizeWithCount } from "@common/helpers/string";

/**
 * Drag preview chip text: the selection ("3 transactions") while moving, and
 * the action ("Add 3 transactions to chat") while a drop would add it.
 */
export function chatDragLabel({
    noun,
    count,
    isOverChat,
}: {
    noun: string;
    count: number;
    isOverChat: boolean;
}): string {
    if (!isOverChat) {
        return pluralizeWithCount(noun, count);
    }
    const items = count === 1 ? noun : pluralizeWithCount(noun, count);
    return `Add ${items} to chat`;
}
